import './App.css';
import MyAppLayout from './components/AppLayout';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GetStarted from './components/GetStartedPage';
import MeetingsPage from './components/MeetingsPage';
import LearnMore from './components/LearnMore';
import Documentation from './components/Documentation';
import CallbackHandler from './components/CallbackHandler';
import { AuthProvider, useAuth } from './components/AuthContext';
import LandingPage from './components/CognitoLandingPage';
import Narrative from './components/Narrative';
import Prfaq from './components/Prfaq';
import MeetingDetails from './components/MeetingDetails';
import MeettheTeam from './components/MeettheTeam';
import ArchitectureDiagram from './components/ArchitectureDiagram';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import  VoiceAssistant from './components/VoiceAssistant'

// Component that automatically initiates sign-in
function AutoLogin() {
  const { initiateSignIn } = useAuth();
  
  useEffect(() => {
    initiateSignIn();
  }, [initiateSignIn]);
  
  return <div>Redirecting to login...</div>;
}

function App() {
	useEffect(() => {
    document.body.style.backgroundColor = '#161d26';
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/getstarted" element={
            <ProtectedRoute redirectPath="/login">
              <GetStarted />
            </ProtectedRoute>} />
          <Route path="/login" element={<AutoLogin />} />
          <Route path="/meetings" element={
            <ProtectedRoute redirectPath="/login">
              <MeetingsPage />
            </ProtectedRoute>} />
          {/* <Route path="/meetings" element={<MeetingsPage/>} /> */}
          <Route path="/meeting/:meetingId" element={
            <ProtectedRoute redirectPath="/login">
              <MeetingDetails />
            </ProtectedRoute>
          } />
          <Route path="/callback" element={
            <CallbackHandler />
          } />
          <Route path="/learnmore" element={
            <ProtectedRoute redirectPath="/login">
              <LearnMore />
            </ProtectedRoute>} />
          <Route path="/documentation" element={
            <ProtectedRoute redirectPath="/login">
              <Documentation />
            </ProtectedRoute>} />
          <Route path="/meettheteam" element={
            <ProtectedRoute redirectPath="/login">
              <MeettheTeam />
            </ProtectedRoute>} />
          <Route path="/narrative" element={
            <ProtectedRoute redirectPath="/login">
              <Narrative />
            </ProtectedRoute>} />
          <Route path="/prfaq" element={
            <ProtectedRoute redirectPath="/login">
              <Prfaq />
            </ProtectedRoute>} />
          <Route path="/architecture" element={
            <ProtectedRoute redirectPath="/login">
              <ArchitectureDiagram />
            </ProtectedRoute>} />
          <Route path="/voice-assistant" element={
            <ProtectedRoute redirectPath="/login">
              <VoiceAssistant />
            </ProtectedRoute>} />
          <Route path="/" element={
            <ProtectedRoute redirectPath="/login">
              <MyAppLayout />
            </ProtectedRoute>
          } />
          <Route path="/*" element={
            <LandingPage />
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

function ProtectedRoute({ children, redirectPath }) {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  // run this after the initial render (or when the state changes)
  useEffect(() => {
    // redirect to login if both false, will re-run when one changes
    if (!isLoading && !isAuthenticated) {
      navigate("/login");
    }
  }, [isLoading, isAuthenticated, navigate]);

  // Initial loading page, this will re-run on change
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Only render children if authenticated
  return isAuthenticated ? children : null;
}

export default App;
